<template lang="pug">
  div(data-testid="content-favorite")
    section.content-header
      app-messages(:errorMessages="errors", :successMessages="successes")

      h1 読み取り不能名刺

    section.content
      .callout.callout-info.bcard-callout
        p 画像から登録した名刺のうち、エラーになったものを表示しています。
        p
          i.fa.fa-fw.fa-exclamation-circle
          |
          |
          | 名刺情報を修正するか、新たに名刺を登録しなおしてください。

      .bcard-btnbar.clearfix(v-if="list.length")
        func-del-log(:checked-ids="checkedIds", @submit="bulkDelete")

      .panel.panel-default
        loading(v-if="isLoading")
        .table-responsive(v-else-if="list.length > 0")
          table.table.table-striped.table-bordered.bcard-table
            thead
              tr
                th.bcard-table-td-chk
                  input(type="checkbox", @change="checkAll(list, $event.target.checked)")
                th.thd-name 名刺/アップロード日時
                  i.fa.fa-sort-desc.bcard-table-sort-header-icon
                th.td-proxy 修正サービス
                th.thd-exchange 名刺交換日
            tbody
              tr(v-for="item in list", :key="item.id", :class="{'selected': isChecked(item.id)}")
                td.bcard-table-td-chk
                  input(type="checkbox", :checked="isChecked(item.id)", @change="checkItem(item.id, $event.target.checked)")
                td.thd-name
                  .row
                    .col-xs-5
                      .bcard-card-readerr-card-img-wrap
                        img(
                          :src="app_imgsrc.now_loading",
                          v-src="item.image_url",
                          :alt="item.full_name || item.dispname",
                          :title="item.full_name || item.dispname"
                        )
                    .col-xs-7
                      router-link.text(:to="{name: 'box-detail', params: {sidPerson: item.sid_person}}")
                        i.fa.bcard-fa-person-private(v-if="item.openflag === '0'" title="非公開")
                        |
                        |
                        | {{item.lang_status}}

                      //- アップロード日時
                      hr
                      i.fa.fa-fw.fa-mobile(v-if="item.terminal === '2'")
                      i.fa.fa-fw.fa-desktop(v-else)
                      |
                      |
                      | {{item.lang_terminal}} から
                      br
                      | {{item.formatted_uploadtime}}

                td
                  template(v-if="item.input_proxy === app_flag.ON")
                    | 利用する
                  template(v-else)
                    | 利用しない

                td {{item.formatted_exdate}}

        .panel-body.text-center(v-else) 読み取り不能な名刺はありません。

      app-pagination(:is-loading="isLoading", :pagination="pagination", @change="getList")
</template>

<script>
import mixinList from '@/mixins/list'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import Loading from '@/components/molecules/Loading'
import FuncDelLog from './FuncDelLog'
// import FuncExport from '@/components/organisms/functions/FuncExport'
// import FuncFavorite from '@/components/organisms/functions/FuncFavorite'
// import LatestLabel from '@/components/molecules/LatestLabel'

export default {
  name: 'ReaderrBcards',
  components: {
    AppMessages,
    AppPagination,
    Loading,
    FuncDelLog
  },
  mixins: [ mixinList ],
  data () {
    return {
      isLoading: true,

      // ソート項目リスト
      // sortOptions: [
      //   {'label': '氏名', 'sort_item': 'name'},
      //   {'label': '会社名', 'sort_item': 'corporate_name'},
      //   {'label': '名刺交換日', 'sort_item': 'exchange_date'}
      // ],

      // 初期条件
      initParams: {
        // ページ条件
        page: { page: 1 }
        // // ソート条件
        // sort: { sort_item: 'name', direction: 'asc' },
        // // 検索条件
        // conds: {}
      }
    }
  },
  created () {
    // サイドメニューから遷移した場合、mixinListで取得しているstoreの条件を上書きする
    if (this.$route.params.init) {
      this.pagination = Object.assign({}, this.initParams.page)
      // this.sort = Object.assign({}, this.initParams.sort)
      // this.conditions = Object.assign({}, this.initParams.conds)
    }

    // 初期データ取得
    this.getList()
  },
  methods: {
    /**
     * 一覧取得処理
     * @params options
     *    page: ページ条件
     *    sort: ソート条件
     *    conds: 検索条件
     */
    getList (options) {
      const vm = this
      options = options || {}

      let page = options.page || this.pagination.current_page || 1

      let params = {
        // page
        page
      }

      this.clearErrorMessages()
      this.isLoading = true

      // API実行
      this.sendListRequest({
        repo: 'bimage',
        method: 'getErrors',
        params,
        finally () {
          vm.isLoading = false
        }
      })
    },
    isError (item) {
      // statusが'一部読取不能', '読取不能'
      return item.status === '7' || item.status === '8'
    },
    bulkDelete () {
      // API実行
      const vm = this
      this.sendBulkRequest('bimage', 'bulkDelete', {
        params: {
          id: this.checkedIds
        },
        onSuccess: function (response) {
          vm.showToast('画像から登録したログの削除に成功しました。', { type: 'success' })
          // サイドメニューの件数更新
          vm.$store.dispatch('reloadSidemenu')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';

  .td-proxy { width: 9em; }

  .bcard-card-readerr-card-img-wrap {
    /*padding: $table-cell-padding;*/
    height: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ebebeb; /* not foundの枠と同じ色 */
    > img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain; /* IE 効かない */
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/maintenance/readerr-bcards/Index.vue